import WidgetBody from './Body';

export default WidgetBody;
